import React from 'react';
import { Modal, Stack, Text, Flex, Button } from '@mantine/core';

export interface UnsavedChangesWarningModalProps {
    readonly opened: boolean;
    readonly onStay: () => void;
    readonly onLeave: () => void;
    readonly bodyText?: string;
}

const DEFAULT_BODY =
    'You have unsaved changes that will be lost if you leave this page. Are you sure you want to leave?';

export function UnsavedChangesWarningModal({
    opened,
    onStay,
    onLeave,
    bodyText = DEFAULT_BODY,
}: UnsavedChangesWarningModalProps) {
    return (
        <Modal
            opened={opened}
            onClose={onStay}
            title="You have unsaved changes"
            centered
            size="md"
            radius="md"
            classNames={{ title: 'text-2xl font-bold' }}
        >
            <Stack gap="lg">
                <Text size="sm" c="dark.7">
                    {bodyText}
                </Text>
                <Flex justify="flex-end" gap="sm" mt="md">
                    <Button
                        variant="outline"
                        size="sm"
                        radius="xl"
                        fullWidth={false}
                        color="gray"
                        onClick={onStay}
                    >
                        Stay
                    </Button>
                    <Button
                        variant="filled"
                        size="sm"
                        radius="xl"
                        fullWidth={false}
                        color="red"
                        onClick={onLeave}
                    >
                        Leave
                    </Button>
                </Flex>
            </Stack>
        </Modal>
    );
}
